import React, { useCallback, useState } from 'react';

import { ReactComponent as HelpIcon } from 'assets/icons/help.svg';
import { ReactComponent as CopyIcon } from 'assets/icons/copy.svg';

import { ListItemText, Menu, MenuItem } from '@mui/material';

import useStyles from 'components/HelpMenu/styles';
import { enqueueSnackbar } from 'notistack';

export const supportEmail: string = 'help@support.mspprocess.com';
export const knowledgeBaseLink: string = 'https://kb.mspprocess.com/';

const HelpMenu: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | SVGSVGElement>(null);
  const open = Boolean(anchorEl);

  const classes = useStyles();

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<SVGSVGElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleCopyEmail = useCallback((e: React.SyntheticEvent): void => {
    e.stopPropagation();
    e.preventDefault();
    window.navigator.clipboard.writeText(supportEmail);
    enqueueSnackbar('Copied to clipboard', { variant: 'success' });
    handleClose();
  }, []);

  const handleNavigateToKnowledgeBase = useCallback(() => {
    window.open(knowledgeBaseLink, '_blank');
  }, []);

  return (
    <>
      <HelpIcon onClick={handleClick} />

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleNavigateToKnowledgeBase}>
          <ListItemText>Knowledge Base</ListItemText>
        </MenuItem>

        <MenuItem onClick={handleCopyEmail}>
          <ListItemText>Support</ListItemText>

          <CopyIcon className={classes.icon} onClick={handleCopyEmail} />
        </MenuItem>
      </Menu>
    </>
  );
};

export default HelpMenu;
